export const enum SupportChatResendStatus {
    Sent = 0,
    AlreadySent = 1,
    Failed = 2
}
